import { createContext, useContext } from 'react';

/**
 * 问卷编辑页：自动保存成功时在顶栏展示「已保存」，替代 message.success 弹窗。
 */
const SurveyAutosaveContext = createContext({
    notifySaved: () => {},
});

export function useSurveyAutosave() {
    return useContext(SurveyAutosaveContext);
}

export default SurveyAutosaveContext;
